import React from "react";
import { Redirect, Switch } from "react-router-dom";
import { ContentRoute } from "../../../_metronic/layout/components/content/ContentRoute";
import { CustomerInquiry } from "./customerInquiry";
import AwaitedSettelmentSales from "./factor/awaitedSettelmentSales";
import ProformaInvoice from "./factor/proformaInvoice";
import OpenSalesTable from "./openSale/openSalesTable";
import SaleFactorDetail from "./saleFactorDetail";
import SaleFactorFilesStep from "./saleFactorFilesStep";
import SaleFactorOtpStep from "./saleFactorOtpStep";

export default function SaleConfigPage() {
  return (
    <Switch>
      {<Redirect exact={true} from="/sale" to="/sale/customerInquiry" />}
      <ContentRoute
        path="/sale/customerInquiry"
        component={CustomerInquiry}
        label={undefined}
        children={undefined}
        render={undefined}
      />
      <ContentRoute
        path="/sale/saleFactorOtpStep"
        component={SaleFactorOtpStep}
        label={undefined}
        children={undefined}
        render={undefined}
      />
      <ContentRoute
        path="/sale/saleFactorFilesStep"
        component={SaleFactorFilesStep}
        label={undefined}
        children={undefined}
        render={undefined}
      />
      <ContentRoute
        path="/sale/saleFactorDetail"
        component={SaleFactorDetail}
        label={undefined}
        children={undefined}
        render={undefined}
      />
      <ContentRoute
        path="/sale/ProformaInvoice"
        component={ProformaInvoice}
        label={undefined}
        children={undefined}
        render={undefined}
      />
      <ContentRoute
        path="/sale/openSales"
        component={OpenSalesTable}
        label={undefined}
        children={undefined}
        render={undefined}
      />
      {/* <ContentRoute
        path="/sale/WaitForSettlement"
        component={WaitForSettlement}
        label={undefined}
        children={undefined}
        render={undefined}
      />
      <ContentRoute
        path="/sale/WaitForSettlementByCustomer"
        component={WaitForSettlementByCustomer}
        label={undefined}
        children={undefined}
        render={undefined}
      /> */}

      <ContentRoute
        path="/sale/AwaitedSettelmentSales"
        component={AwaitedSettelmentSales}
        label={undefined}
        children={undefined}
        render={undefined}
      />
    </Switch>
  );
}
